import React from 'react'
import './Footer.css'
import logo from '../images/blinkk_logo.png'
import { FaFacebookF } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { ImWhatsapp } from "react-icons/im";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './DropdownContent.css'
import { Link } from "react-router-dom";
import blinkk from '../images/Blinkk.png'
import Leftcont from './Leftcont';

export default function Footer() {
  return (
    <div className='footer'>
      <div className='horizontal_line'>
      </div>
      <div className='store footer_store_details'>
      
      <div className='name_logo'>
         
          <img className='blinkk_text' src={blinkk} alt='Blinkk optical' />
          <img src={logo} alt='Blinkk optical' />
        </div>
        <div className='store_type'>
          <p className='store_name'>
          
              OPTICAL STORE
            
          </p>
        </div>
      </div>
      <div className='company_details'>
        <Navbar expand="lg">
          <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link href="#home">About Us</Nav.Link>
                <Nav.Link href="#home">Customer Service</Nav.Link>
                <Nav.Link href="#home">Privacy Policy</Nav.Link>
                <Nav.Link href="#home">Contact Us</Nav.Link>
                <Nav.Link href="#home">Blog</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
      <div className='social_icons footer_social_icons'>
        <Link to='https://www.facebook.com/profile.php?id=100082214063436&mibextid=ZbWKwL'>
          <FaFacebookF />
        </Link>
        <Link to='https://wa.me/message/66PAG4QM7AB7D1'>
          <ImWhatsapp />
        </Link>
        <Link to='https://www.instagram.com/blinkkopticals?r=nametag'>
          <BsInstagram />
        </Link>
      </div>
      <div className='horizontal_line'>
      </div>
      <div className='copy_right'>
        <p>© 2023 Blinkk. All Right Reserved.</p>
        <p>© Design & Developed by Shubham Biswas.</p>
      </div>
    </div>
  )
}
